module.exports = __webpack_public_path__ + "img/qshkRule2.f4e4b2a8.png";